import React from "react";
import { Hammer, ShoppingCart } from "lucide-react";
import MerkezHubShell from "@/components/MerkezHubShell";

const TABS = [
    { id: "uzman", label: "Hasar Uzmanı", icon: Hammer },
    { id: "satin-alma", label: "Hasar Satın Alma", icon: ShoppingCart },
];

export default function EkspertizHasarMerkezLayout() {
    return (
        <MerkezHubShell
            title="Hasar & Ekspertiz Merkezi"
            subtitle="Sigorta hasar fark analizi, parça piyasa istihbaratı ve hasar satın alma teklifi."
            badge="Ekspertiz · Piyasa · Satın Alma"
            basePath="/yeni/rayic-parca-merkezi/hasar"
            tabs={TABS}
        />
    );
}
